export const exponentialBackOff = async <T>(
  fn: () => Promise<T>,
  depth = 0,
  timeoutCeiling = 1000,
  suppressErrors = true
): Promise<T | null> => {
  try {
    return await fn();
  } catch (e) {
    if (depth > 10) {
      if (suppressErrors) return null;

      throw e;
    }

    await new Promise(res => setTimeout(res, Math.min(2 ** depth * 10, timeoutCeiling)));

    return exponentialBackOff(fn, depth + 1);
  }
};
